export const BOGGLE_GOLD_TILE_KIND = 'gold'
export const BOGGLE_BLUE_TILE_KIND = 'blue'
export const BOGGLE_PURPLE_TILE_KIND = 'purple'
export const BOGGLE_GOLD_SCORE_BONUS = 1
export const BOGGLE_BLUE_TIME_BONUS_MS = 2000

export const BOGGLE_SPECIAL_TILE_KINDS = [
  BOGGLE_GOLD_TILE_KIND,
  BOGGLE_BLUE_TILE_KIND,
  BOGGLE_PURPLE_TILE_KIND,
] as const

export type BoggleSpecialTileKind = (typeof BOGGLE_SPECIAL_TILE_KINDS)[number]
